import React, { useState } from 'react';
function IdealWeight({ result}) {
  return (
    <table >
      <thead>
        <tr>
          <th >Formule/Équation</th>
          <th >Poids idéal</th>
        </tr>
      </thead>
      <tbody>
        <tr >
          <td>Hamwi (1964)	</td>
          <td>{result.hamwi} kg</td>
        </tr>
        <tr >
          <td>Devine (1974)	 </td>
          <td>{result.devine} kg </td>
        </tr>
        <tr >
          <td>Robinson (1983)</td>
          <td>{result.robinson} kg</td>
        </tr>
        <tr >
        <td>
        Miller (1983)
          </td>
          <td>{result.miller} kg</td>
        </tr>
        <tr >
          <td>Indice de masse corporelle (IMC) sain</td>
          <td>{result.bmiRange.lower} - {result.bmiRange.upper} kg </td>
        </tr>
      </tbody>
    </table>
  );
}
export default IdealWeight;